<template>
  <transition @leave="leave">
    <a-entity>
      <a-image
        ref="logo"
        :src="cdn(require('@/components/infos/img/roxham.png'))"
        height=".5" width=".5"
        material="shader: flat; depthTest: false"
        transparent="true"
        opacity="0"
        shader="flat" position="0 .1 -.8"
        @materialtextureloaded="loaded"
      />

      <a-image
        ref="btn"
        class="Fuse"
        :src="cdn(require('@/components/wait/img/text-intro-btn-fr.png'))"
        height=".15" width=".15"
        transparent="true"
        material="shader: flat; depthTest: false"
        opacity="0"
        position="-.1 -.1 -.8"
        @materialtextureloaded="loaded"
        @click="$router.push({ name: 'load.fr'})"
      />

      <a-image
        ref="btn"
        class="Fuse"
        :src="cdn(require('@/components/wait/img/text-intro-btn-en.png'))"
        height=".15" width=".15"
        transparent="true"
        material="shader: flat; depthTest: false"
        opacity="0"
        position=".1 -.1 -.8"
        @materialtextureloaded="loaded"
        @click="$router.push({ name: 'load.en' })"
      />
    </a-entity>
  </transition>
</template>

<script>
export default {
  name: 'VrStart',
  methods: {
    loaded(e) {
      TweenLite.to(e.target, 1, { aframe: { alpha: 1 }})
    },
    leave(el, done) {
      TweenLite.to([this.$refs.btn, this.$refs.logo], 1, { aframe: { alpha: 0 }, onComplete: done })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/vr-start/VrStart.vue